/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { Cancel, CheckCircle, RadioButtonUnchecked } from '@material-ui/icons'
import PropTypes from 'prop-types'
import * as Constants from '../../../constants'
import { getFittingLength, getPasswordErrors, PasswordRules } from '../../../utils/passwordPolicy'

const unmetColor = 'rgba(255, 255, 255, 0.6)'

const styles = {}

styles.list = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2px 12px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 11px;
  line-height: 1.2;
`

styles.item = css`
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
`

const requirements = [
  PasswordRules.MIN_LENGTH,
  PasswordRules.UPPERCASE,
  PasswordRules.LOWERCASE,
  PasswordRules.NUMBER
]

// Text of a password rule. The maximum length tells how many characters fit, as characters like
// 'ñ' or '中' take several bytes and lower it.
function getRequirementText(rule, password) {
  if (rule === PasswordRules.MAX_LENGTH) {
    return window.I18n.t('createUser.passwordRequirements.maxLength', {
      count: getFittingLength(password)
    })
  }

  return window.I18n.t(`createUser.passwordRequirements.${rule}`, {
    count: Constants.PasswordPolicy.minLength
  })
}

function PasswordRequirements(props) {
  const errors = getPasswordErrors(props.password)
  return (
    <ul css={styles.list}>
      {requirements.map(rule => {
        const isMet = !errors.includes(rule)
        return (
          <li key={rule} css={styles.item} style={{ color: isMet ? props.color : unmetColor }}>
            {isMet ? (
              <CheckCircle fontSize="inherit" />
            ) : (
              <RadioButtonUnchecked fontSize="inherit" />
            )}
            {getRequirementText(rule, props.password)}
          </li>
        )
      })}
      {errors.includes(PasswordRules.MAX_LENGTH) && (
        <li css={styles.item} style={{ color: Constants.theme.palette.error.light }}>
          <Cancel fontSize="inherit" />
          {getRequirementText(PasswordRules.MAX_LENGTH, props.password)}
        </li>
      )}
    </ul>
  )
}

PasswordRequirements.propTypes = {
  password: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
}

export default PasswordRequirements
